"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const api_1 = __importDefault(require("../api"));
const types_1 = require("../../types");
const common_1 = require("../common");
(0, web_ui_1.$)(document).ready(() => {
    const card = (0, web_ui_1.$)('#staff-login-card');
    (0, web_ui_1.$)('#staff_login_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const staff_login = (0, web_ui_1.$)('#staff_login');
        const staff_secret = (0, web_ui_1.$)('#staff_secret');
        const staff_email = staff_login.val();
        const staff_password = staff_secret.val();
        try {
            web_ui_1.LoadingOverlay.show();
            const result = yield api_1.default.staffLogin(staff_email.trim(), staff_password.trim());
            if (result === types_1.HTTPError.OK) {
                staff_login.val('');
                staff_secret.val('');
                return (0, common_1.swapCard)(card, (0, web_ui_1.$)('#staff-portal-card'));
            }
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'Invalid Credentials Supplied',
                body: 'Please check your information and try again'
            });
        }
        catch (_a) {
            web_ui_1.LoadingOverlay.hide();
        }
    }));
});
